import { NumberField, Show, TextField } from "react-admin";
import CustomDateField from "shared/components/fields/CustomDateField";

const TopNiveauBidsShow = () => {
  return (
    <Show>
      <TextField source="id" />
      <CustomDateField source="created_at" locales={"fr-FR"} showTime />
      <CustomDateField source="updated_at" locales={"fr-FR"} showTime />
      <NumberField source="max_quantity" />
      <NumberField source="min_quantity" />
      <NumberField source="price" />
      {/* TODO: add ReferenceField once Backend updated */}
      <TextField source="edr_id" label={"EDR code"} />
      <TextField source="direction" />
      <NumberField source="fat" />
      <TextField source="gate_id" />
      {/* TODO: add ReferenceField once Backend updated */}
      {/* <ReferenceField source="gate_id" reference={TopNiveauResourcesEnum.TopNiveauGates} /> */}
    </Show>
  );
};

export default TopNiveauBidsShow;
